import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import {
    NavLink as RouterNavLink,
    Route,
    Switch,
    Redirect,
    useHistory,
    useParams
} from "react-router-dom";
import { getParamsAttachedRoute } from "../../helpers/routeHelpers";

const RoutingTabs = ({
    config = null,
    isTabs = true,
    isPills = false,
    isFill = false,
    parentRoute = ""
}) => {
    const history = useHistory();
    const params = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const currentPath = history?.location?.pathname;

    useEffect(() => {
        const initializeActiveTab = () => {
            const tab = config.tabsConfig.find((item) => {
                const route = getParamsAttachedRoute(item.path, { ...params });
                return currentPath === route || currentPath.startsWith(route + "/");
            });

            // Set activeTab to the matched tab, or default to the `defaultActive` tab
            setActiveTab(tab || config.tabsConfig.find((item) => item.defaultActive));
        };

        initializeActiveTab();

        // If the current path is exactly the parent route, redirect to the default active tab
        if (currentPath === parentRoute) {
            const defaultTab = config.tabsConfig.find((item) => item.defaultActive);
            if (defaultTab) {
                history.replace(getParamsAttachedRoute(defaultTab.path, config?.param));
            }
        }
    }, [currentPath, config, params, parentRoute, history]);

    const handleSetActiveTab = (tab) => setActiveTab(tab);

    const getRedirect = () => {
        // Redirect to the default tab when no active tab is detected
        if (!activeTab) {
            const defaultTab = config.tabsConfig.find((item) => item.defaultActive);
            return <Redirect to={getParamsAttachedRoute(defaultTab?.path, config?.param)} />;
        }

        return null;
    };

    return (
        <div>
            <Nav tabs={isTabs} pills={isPills} fill={isFill}>
                {config.tabsConfig.map((item) =>
                    item?.title ? (
                        <NavItem key={item.id}>
                            <NavLink
                                exact
                                tag={RouterNavLink}
                                to={getParamsAttachedRoute(item.path, config?.param)}
                                onClick={() => handleSetActiveTab(item)}
                                className={`tab-link ${activeTab?.id === item.id ? "active" : ""}`}
                            >
                                {item.title}
                            </NavLink>
                        </NavItem>
                    ) : (
                        <></>
                    )
                )}
            </Nav>

            <TabContent activeTab={activeTab?.id}>
                <Switch>
                    {/* Parent routes */}
                    {config.tabsConfig.map((item, index) => (
                        <Route path={item.path} exact={item.exact} key={index}>
                            <TabPane key={index} tabId={item.id}>
                                {item.component}
                            </TabPane>
                        </Route>
                    ))}

                    {/* Child routes */}
                    {config.tabsConfig.map((item) =>
                        item.children?.map((child, childIndex) => (
                            <Route
                                key={`child-${childIndex}`}
                                path={getParamsAttachedRoute(child.path, config?.param)}
                                exact={child.exact}
                            >
                                <TabPane tabId={item.id}>{child.component}</TabPane>
                            </Route>
                        ))
                    )}

                    {/* Default redirect */}
                    {getRedirect()}
                </Switch>
            </TabContent>
        </div>
    );
};

export default RoutingTabs;
